import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CardToken, CardTokenQuery } from '@fgb/core';
import { Observable } from 'rxjs';
import * as luxon from 'luxon';
@Component({
  selector: 'fgb-add-card-payment',
  templateUrl: './add-card-payment.component.html',
  styleUrl: './add-card-payment.component.scss',
})
export class AddCardPaymentComponent implements OnInit {
  cardToken$: Observable<CardToken | undefined>;
  @Output() onClickNavigate = new EventEmitter<void>();
  constructor(private cardTokenQuery: CardTokenQuery) {}

  ngOnInit(): void {
    this.cardToken$ = this.cardTokenQuery.selectDefaultCard();
  }

  goToJetsCash() {
    this.onClickNavigate.emit();
  }

  isExpired(expiryDate: string) {
    if (!expiryDate) return false;
    const now = luxon.DateTime.utc();
    const expiriedDate = luxon.DateTime.fromISO(expiryDate);
    return now > expiriedDate;
  }
}
